import { URI } from 'vscode/vscode/vs/base/common/uri';
import { localize2WithPath, localizeWithPath } from 'vscode/vscode/vs/nls';
import { Action2, registerAction2, MenuRegistry, MenuId } from 'vscode/vscode/vs/platform/actions/common/actions';
import { CommandsRegistry } from 'vscode/vscode/vs/platform/commands/common/commands';
import { LifecyclePhase } from 'vscode/vscode/vs/workbench/services/lifecycle/common/lifecycle';
import { IQuickInputService } from 'vscode/vscode/vs/platform/quickinput/common/quickInput.service';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { IURLService } from 'vscode/vscode/vs/platform/url/common/url.service';
import { Extensions, registerWorkbenchContribution2, WorkbenchPhase } from 'vscode/vscode/vs/workbench/common/contributions';
import { ExternalUriResolverContribution } from './externalUriResolver.js';
import { manageTrustedDomainSettingsCommand } from 'vscode/vscode/vs/workbench/contrib/url/browser/trustedDomains';
import { TrustedDomainsFileSystemProvider } from './trustedDomainsFileSystemProvider.js';
import { OpenerValidatorContributions } from './trustedDomainsValidator.js';
import { Categories } from 'vscode/vscode/vs/platform/action/common/actionCommonCategories';
import { Extensions as Extensions$1, ConfigurationScope } from 'vscode/vscode/vs/platform/configuration/common/configurationRegistry';
import { workbenchConfigurationNodeBase } from 'vscode/vscode/vs/workbench/common/configuration';
import 'vscode/vscode/vs/workbench/contrib/url/browser/trustedDomainService';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import 'vscode/vscode/vs/platform/instantiation/common/extensions';

const _moduleId = "vs/workbench/contrib/url/browser/url.contribution";
class OpenUrlAction extends Action2 {
    constructor() {
        super({
            id: 'workbench.action.url.openUrl',
            title: ( localize2WithPath(_moduleId, 0, 'Open URL')),
            category: Categories.Developer,
            f1: true
        });
    }
    async run(accessor) {
        const quickInputService = accessor.get(IQuickInputService);
        const urlService = accessor.get(IURLService);
        return quickInputService.input({ prompt: ( localizeWithPath(_moduleId, 1, "URL to open")) }).then(input => {
            if (input) {
                const uri = ( (URI.parse(input)));
                urlService.open(uri, { originalUrl: input });
            }
        });
    }
}
registerAction2(OpenUrlAction);
CommandsRegistry.registerCommand(manageTrustedDomainSettingsCommand);
MenuRegistry.appendMenuItem(MenuId.CommandPalette, {
    command: {
        id: manageTrustedDomainSettingsCommand.id,
        title: manageTrustedDomainSettingsCommand.description.description
    }
});
( (Registry.as(Extensions.Workbench))).registerWorkbenchContribution(OpenerValidatorContributions, LifecyclePhase.Restored);
registerWorkbenchContribution2(TrustedDomainsFileSystemProvider.ID, TrustedDomainsFileSystemProvider, WorkbenchPhase.BlockRestore
);
registerWorkbenchContribution2(ExternalUriResolverContribution.ID, ExternalUriResolverContribution, WorkbenchPhase.BlockRestore
);
const configurationRegistry = ( (Registry.as(Extensions$1.Configuration)));
configurationRegistry.registerConfiguration({
    ...workbenchConfigurationNodeBase,
    properties: {
        'workbench.trustedDomains.promptInTrustedWorkspace': {
            scope: ConfigurationScope.APPLICATION,
            type: 'boolean',
            default: false,
            description: ( localizeWithPath(
                _moduleId,
                2,
                "When enabled, trusted domain prompts will appear when opening links in trusted workspaces."
            ))
        }
    }
});
